import { motion } from "framer-motion";

const items = [
  { y: "2024", title: "JAIMECASTEL", body: "25 artistes locaux et internationaux investissent Castelnau d'Estrétefonds — 4 mois d'exposition en plein air le long du canal." },
  { y: "2025", title: "Canal'Art · Octobre Rose", body: "Deuxième édition engagée dans la lutte contre le cancer du sein. Peinture, photographie, poésie, performance." },
  { y: "2026", title: "Canal'Art 2026 · 30 ans UNESCO", body: "6 escales, 194 artistes en 2026 — représentation UNESCO complète d'ici 2030. Convention 5 ans signée avec VNF et le SGAR. Le Fil du Midi devient officiel." },
  { y: "2027 → 2029", title: "Extension du Fil", body: "Ajout progressif des zones libres du parcours. Fédération des évènements existants. Recrutement d'artistes de chaque pays membre de l'UNESCO." },
  { y: "2030", title: "750 km · 194 pays UNESCO", body: "Le plus grand parcours artistique à ciel ouvert du monde. Chaque pays membre de l'UNESCO présent artistiquement sur le Fil, de l'Atlantique à la Méditerranée." },
];

export default function Timeline() {
  return (
    <section className="relative py-32 md:py-40 px-6 md:px-12" data-testid="timeline">
      <div className="max-w-[1400px] mx-auto">
        <div className="mb-16">
          <div className="meta-label text-cinabre">§ Cap 2030</div>
          <h2 className="font-serif font-light text-5xl md:text-7xl leading-[0.95] tracking-tight mt-6 max-w-3xl">
            Cinq ans<br/>pour <em className="italic">tout relier</em>.
          </h2>
        </div>

        <div className="border-l border-fg/25 ml-4 md:ml-8">
          {items.map((it, i) => (
            <motion.div
              key={it.y}
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, delay: i * 0.06 }}
              className="relative pl-10 md:pl-16 pb-16 last:pb-0"
              data-testid={`timeline-${it.y}`}
            >
              <span className="absolute left-0 top-2 -translate-x-1/2 w-3 h-3 bg-cinabre rounded-full ring-4 ring-bg" />
              <div className="font-mono text-[11px] tracking-[0.24em] uppercase text-fg/60">{it.y}</div>
              <h3 className="font-serif text-3xl md:text-5xl mt-2 leading-tight tracking-tight">{it.title}</h3>
              <p className="mt-4 text-fg/75 max-w-2xl leading-relaxed text-lg">{it.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
